import { modalLogoutTranslate } from './Locale/_index';
import type { IModalLogoutTemplate } from '@/Contexts/GLModalLogout/types/ModalLogoutTemplate.types';

const SonarModalLogout: IModalLogoutTemplate = {
  locale: modalLogoutTranslate,
};

export { SonarModalLogout };
